import './less/sideProductsMenu.less';

const sideProductsMenu = () => {
    
    const init = () => {
        [...document.getElementsByClassName('JS_submenu-opener')].forEach(opener => {
            opener.addEventListener('click', e => {
                console.log(e.currentTarget, e.currentTarget.nextElementSibling);
                e.currentTarget.nextElementSibling.classList.toggle('opened');
            });
        });
        
	    $('.js-products-menu .JS_sideMenuItem.active').closest('.JS_sideSubmenu').addClass("opened");
        
    };
    
    init();
};


const categoriesMenu = sideProductsMenu();

export default categoriesMenu;


// WEBPACK FOOTER //
// ./components/sideProductsMenu/sideProductsMenu.js